"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentSelectionWidget = void 0;
const react_1 = __importStar(require("react"));
const monera_app_core_1 = require("@amzn/monera-app-core");
const apx_payments_portal_widget_1 = require("../apx-payments-portal-widget");
const icons_1 = require("../icons");
const page_wrapper_1 = require("../page-wrapper");
const themed_text_1 = require("../themed-text");
const styles_1 = require("./styles");
const PaymentSelectionWidget = (_a) => {
    var { selectionErrorMessage, isChecked, isPaymentSelectionErrorDisplayed, onCheckChange, onSelectInstrumentIdCallback } = _a, apxProps = __rest(_a, ["selectionErrorMessage", "isChecked", "isPaymentSelectionErrorDisplayed", "onCheckChange", "onSelectInstrumentIdCallback"]);
    const deviceType = (0, react_1.useContext)(page_wrapper_1.PageContext).deviceType;
    const [hasCheckbox, setHasCheckbox] = (0, react_1.useState)(false);
    const handleInstrumentIdCallback = (instrumentId) => {
        setHasCheckbox(!!instrumentId);
        onSelectInstrumentIdCallback === null || onSelectInstrumentIdCallback === void 0 ? void 0 : onSelectInstrumentIdCallback(instrumentId);
    };
    return (react_1.default.createElement(styles_1.Container, { "data-cy": "payment-selection-widget-container" },
        react_1.default.createElement(styles_1.CheckboxPaymentContainer, { error: isPaymentSelectionErrorDisplayed, deviceType: deviceType },
            hasCheckbox && (react_1.default.createElement(styles_1.Checkbox, { checked: isChecked, error: isPaymentSelectionErrorDisplayed, deviceType: deviceType, "aria-label": "Select payment method", onChange: (e) => onCheckChange(e.target.checked) })),
            react_1.default.createElement(apx_payments_portal_widget_1.ApxPaymentsPortalWidget, Object.assign({}, apxProps, { onSelectInstrumentIdCallback: handleInstrumentIdCallback }))),
        isPaymentSelectionErrorDisplayed && (react_1.default.createElement(styles_1.ErrorMessageContainer, null,
            react_1.default.createElement(icons_1.RioAlertIcon, { alertType: "error" }),
            react_1.default.createElement(themed_text_1.ThemedSpan, { font: "base", style: { color: monera_app_core_1.Red_500 } }, selectionErrorMessage)))));
};
exports.PaymentSelectionWidget = PaymentSelectionWidget;
